import {
  Text,
  StyleSheet,
  ViewStyle,
  View,
  ImageStyle,
  Pressable,
  ActivityIndicator,
  TextStyle,
} from "@/ui/index";
import { Colors } from "@/constants";
import Icon, { icons } from "./Icon";
import { getLangDir } from "@/models/utils";

const isRTL = getLangDir() === "rtl";

const PrimaryButton = ({
  text,
  onPress,
  style,
  disabled = false,
  loading = false,
  textStyle = {},
  iconStyle = {},
  height = 40,
  icon,
}: {
  text: string;
  onPress: () => void;
  height?: number;
  disabled?: boolean;
  loading?: boolean;
  style?: ViewStyle;
  textStyle?: TextStyle;
  icon?: keyof typeof icons;
  iconStyle?: ImageStyle;
}) => {
  return (
    <View style={{ flexDirection: "row" }}>
      <Pressable
        disabled={disabled || loading}
        onPress={onPress}
        style={StyleSheet.flatten([
          {
            ...s.container,
            height,
            backgroundColor: Boolean(disabled || loading)
              ? Colors.gray6
              : Colors.accent,
          },
          style || {},
        ])}
      >
        <View style={{ flexDirection: "row", alignItems: "center" }}>
          {!loading && icon && (
            <Icon icon={icon} style={StyleSheet.flatten([s.icon, iconStyle])} />
          )}
          {!loading && (
            <Text style={StyleSheet.flatten([s.text, textStyle])}>{text}</Text>
          )}
          {loading && <ActivityIndicator size="small" color={Colors.white} />}
        </View>
      </Pressable>
    </View>
  );
};

const s = StyleSheet.create({
  container: {
    borderRadius: 8,
    backgroundColor: Colors.accent,
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: 40,
    paddingHorizontal: 20,
  },
  text: {
    fontWeight: "500",
    color: Colors.white,
    fontSize: 14,
    lineHeight: 20,
  },
  icon: {
    marginRight: isRTL ? 0 : 8,
    marginLeft: isRTL ? 8 : 0,
    tintColor: Colors.white,
  },
});

export default PrimaryButton;
